import './App.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// COMPONENTS
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { useState, useEffect } from 'react';
// VIEWS

// API
import { ThemeProvider, createTheme } from '@mui/material';
import {
  HomePage,
  Mentee,
  Mentor,
  MenteeDashboard,
  MentorDashboard,
  MenteeReview,
  MentorReview,
} from './views';
import { ProfileContextProvider, useProfile } from './contexts';
import { __HEADERS_URL__ } from './helpers';

const theme = createTheme({
  palette: {
    primary: {
      light: '#007ed9',
      main: '#006BB7',
      dark: '#004282',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#61D19E',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
  typography: {
    fontFamily: [
      'Montserrat',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

export async function updateLoginButton(loggedIn) {
  let finish = false;
  const maxRetries = 4;
  let retry = 0;
  while (!finish && retry <= maxRetries) {
    const logoutButton = document.querySelector('#logout');
    const logoutButtonDropdown = document.querySelector('#logout-dropdown');
    if (logoutButton && logoutButtonDropdown && loggedIn) {
      finish = true;
      logoutButton.innerHTML = 'Log Out';
      logoutButton.href = '/logout';
      logoutButtonDropdown.innerHTML = 'Log Out';
      logoutButtonDropdown.href = '/logout';
    }
    await new Promise((resolve) => setTimeout(resolve, 100));
    retry++;
  }
}

const App = () => {
  const { profile } = useProfile();
  if (profile?.email) {
    updateLoginButton(!!profile?.email);
  }
  return (
    <div
      className="App-container"
      style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
    >
      <header className="header App-title">
        <a href="/">
          <img
            src="/NAR_SPIRE_Logo.webp"
            alt="logo"
            style={{ maxWidth: '10rem' }}
          />
        </a>
        <h1 className="page-title">NAR’s Mentorship Program</h1>
      </header>
      <div
        style={{
          flexGrow: 1,
          color: '#333333',
          fontSize: '17px',
          lineHeight: '2.0625',
        }}
      >
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/mentor" element={<Mentor />} />
              <Route path="/mentee" element={<Mentee />} />
              <Route
                path="/admin/mentee/dashboard"
                element={<MenteeDashboard />}
              />
              <Route path="/admin/mentee/review" element={<MenteeReview />} />
              <Route
                path="/admin/mentor/dashboard"
                element={<MentorDashboard />}
              />
              <Route path="/admin/mentor/review" element={<MentorReview />} />
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </div>
    </div>
  );
};

const AppWrapper = () => {
  const [queryClient] = useState(() => new QueryClient());
  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider context={{}}>
        <Helmet>
          <link rel="stylesheet" href={__HEADERS_URL__ + '/index.css'} />
          <script
            type="text/javascript"
            src={__HEADERS_URL__ + '/index.js'}
          ></script>
        </Helmet>
        <ProfileContextProvider>
          <App />
        </ProfileContextProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
};

export default AppWrapper;
